module.exports = "/_next/static/images/5561762a44a6bd891f00999f6d37e7a1-hero-xs.jpg.webp";